/* eslint-disable react/no-multi-comp */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  Document,
  Font,
  Image,
  Page,
  Text,
  PDFViewer,
  PDFDownloadLink,
  StyleSheet,
} from '@react-pdf/renderer';

// import certBG from './cert-cn.jpg';

Font.register({
  family: 'NotoSerifSC',
  src: '/noto-sans-sc-v26-latin_chinese-simplified-regular.woff',
});
const styles = StyleSheet.create({
  body: {
    backgroundColor: '#104989',
  },
  name: {
    fontSize: 20,
    position: 'absolute',
    top: '250px',
    left: '0px',
    right: '0px',
    textAlign: 'center',
    fontFamily: 'NotoSerifSC',
  },
  image: {
    width: '100%',
    maxHeight: '100%',
    position: 'absolute',
    zIndex: -1,
  },
  achievementDate: {
    fontSize: 14,
    position: 'absolute',
    top: '395px',
    left: '10px',
    right: '0px',
    width: '100%',
    textAlign: 'center',
  },
});

interface ICertificateProps {
  name: string;
  date: string;
  background: string;
}
const Certificate: React.FunctionComponent<ICertificateProps> = (props) => (
  <Document>
    <Page orientation="landscape" style={styles.body}>
      <Text style={styles.name}>{props.name}</Text>
      <Text style={styles.achievementDate}>{props.date}</Text>
      <Image style={styles.image} src={props.background} />
    </Page>
  </Document>
);

export const CertificateContainer: React.FunctionComponent<
  ICertificateProps
> = (props) => (
  <div style={{ textAlign: 'center' }}>
    <PDFViewer width="100%" height="800px" showToolbar={false}>
      <Certificate
        name={props.name}
        date={props.date}
        background={props.background}
      />
    </PDFViewer>
    {/* <PDFDownloadLink
      style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 999 }}
      document={<Certificate name={props.name} date={props.date} />}
      fileName="cert.pdf"
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          ''
        ) : (
          <Button type="primary" icon={<DownloadOutlined />}>
            Download
          </Button>
        )
      }
    </PDFDownloadLink> */}
  </div>
);

export default Certificate;
